import { jsx as _jsx } from "react/jsx-runtime";
import { AnnotationOutlinePlus } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { memo } from "react";
import { ANNOTATE_ACTION_BUTTON } from "~/constants/testIDs";
export const AnnotateActionButton = /*#__PURE__*/ memo((param)=>{
    let { isActive, shouldDisableTimestampsAndAnnotations, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: shouldDisableTimestampsAndAnnotations ? "Annotation commenting is disabled during video processing" : "Add contextual comments",
        side: "top",
        children: /*#__PURE__*/ _jsx(IconButton, {
            appearance: isActive ? "filled" : "ghost",
            color: isActive ? "blue" : "grey",
            disabled: shouldDisableTimestampsAndAnnotations,
            icon: AnnotationOutlinePlus,
            label: "Annotate",
            "data-test-id": ANNOTATE_ACTION_BUTTON,
            size: "small",
            ...restOfProps
        })
    });
});
AnnotateActionButton.displayName = "AnnotateActionButton";
